"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _shape = _interopRequireDefault(require("./shape"));
var _bbox = require("../../util/bbox");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var Arc = /*#__PURE__*/function (_Shape) {
  _inheritsLoose(Arc, _Shape);
  function Arc() {
    return _Shape.apply(this, arguments) || this;
  }
  var _proto = Arc.prototype;
  _proto._initProperties = function _initProperties() {
    _Shape.prototype._initProperties.call(this);
    this._attrs.canStroke = true;
    this._attrs.canFill = true;
    this._attrs.type = 'arc';
  };
  _proto.getDefaultAttrs = function getDefaultAttrs() {
    return {
      x: 0,
      y: 0,
      r: 0,
      startAngle: 0,
      endAngle: Math.PI * 2,
      anticlockwise: false,
      lineWidth: 1
    };
  };
  _proto.createPath = function createPath(context) {
    var attrs = this.get('attrs');
    var x = attrs.x,
      y = attrs.y,
      r = attrs.r,
      startAngle = attrs.startAngle,
      endAngle = attrs.endAngle,
      anticlockwise = attrs.anticlockwise;
    context.beginPath();
    if (startAngle !== endAngle) {
      context.arc(x, y, r, startAngle, endAngle, anticlockwise);
    }
  };
  _proto.calculateBox = function calculateBox() {
    var attrs = this.get('attrs');
    var x = attrs.x,
      y = attrs.y,
      r = attrs.r,
      startAngle = attrs.startAngle,
      endAngle = attrs.endAngle,
      anticlockwise = attrs.anticlockwise;
    return (0, _bbox.getBBoxFromArc)(x, y, r, startAngle, endAngle, anticlockwise);
  };
  return Arc;
}(_shape["default"]);
var _default = Arc;
exports["default"] = _default;